import React from "react";
import PropTypes from "prop-types";

import Slideshow from "../../slideshow";
import CmsMarkdown from "../../basic/cms-markdown";

class Col1Slideshow extends React.Component {
  render() {
    const { background_color, id, images, header } = this.props;
    return (
      <div
        className={`cms-col-1-slideshow cms-col-1-slideshow-${id}`}
        style={{ backgroundColor: background_color || "transparent" }}
        {...this.props}
      >
        <div className="container-r-narrow mx-auto">
          {header && (
            <div className="col-group container-lg p-responsive header-container">
              <CmsMarkdown content={header} />
            </div>
          )}
          <div className="container-lg p-responsive">
            <Slideshow slides={images} />
          </div>
        </div>
      </div>
    );
  }
}

Col1Slideshow.propTypes = {
  background_color: PropTypes.string,
  id: PropTypes.string,
  images: PropTypes.array.isRequired,
  header: PropTypes.string
};

export default Col1Slideshow;
